export const MotoInsuranceRequireModel = [
    {
      formName: 'formMotoInsurancePlan',
      fieldRequired: [
        'exploitingType',
        'businessProgramCode',
        'exploitingCode',
        'curencyMoney',
        'curencyFee',
        'exchangeRate',
      ],
    },
    {
      formName: 'formMotoListInsured',
      fieldRequired: [
        'certType',
        'packageCode',
        'vehicleGroupsCode',
        'vehicleOwner',
        'address',
        'startDate',
        'yearNumber',
      ],
    },
    {
      formName: 'formMotoContract',
      fieldRequired: [
        'contractType',
        'purchaseDate',
        'startDate',
        'endDate',
        'taxType',
      ],
    },
  ]
  